module.exports = __webpack_public_path__ + "img/20190622141336微信截图_20190622141737.6fc3735b.png";